export default "__VITE_ASSET__92e890ce__"